import React, { useState } from "react";
import "./styles.scss";
import { GetIconByName } from "../../config/icon";
import { imageUpload, pdfUpload } from "./service/pdf.service";
import { Store } from "react-notifications-component";
import { Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";

const Index = ({ data, onClick, onChange }) => {
  const [isLoading, setIsLoading] = useState(false);

  const onChangeFile = async (e) => {
    setIsLoading(true);
    try {
      console.log("File Upload Event:", e);
      e.preventDefault();

      let files = e.dataTransfer ? e.dataTransfer.files : e.target.files;

      if (!files || files.length === 0) {
        console.warn("No files selected.");
        return;
      }

      const selectedFile = files[0];

      const MAX_FILE_SIZE = data.fileSize * 1024 * 1024;

      // Check file size (if specified)
      if (data.fileSize && selectedFile.size > MAX_FILE_SIZE) {
        alert(`File size exceeds ${data.fileSize}MB limit.`);
        return;
      }

      const reader = new FileReader();

      reader.onload = async () => {
        const base64Data = reader.result;
        console.log("Base64 File:", base64Data);

        // Send to backend
        const response = await pdfUpload({
          name: selectedFile.name,
          filename: selectedFile.name,
          type: selectedFile.type,
          size: selectedFile.size,
          base64_data: base64Data,
          file: selectedFile,
          lastModified: selectedFile.lastModified,
          lastModifiedDate: selectedFile.lastModifiedDate,
        });

        console.log("File Upload Response:", response);

        if (response?.data) {
          onChange(response.data);
          Store.addNotification({
            title: "Success",
            message: "Image Upload successfully",
            type: "success",
            container: "top-right",
            dismiss: {
              duration: 2000,
              onScreen: true,
            },
          });
        } else {
          Store.addNotification({
            title: "Error",
            message: "Image Upload failed",
            type: "danger",
            container: "top-right",
            dismiss: {
              duration: 2000,
              onScreen: true,
            },
          });
        }
        setIsLoading(false);
      };

      reader.onerror = () => {
        setIsLoading(false);
        alert("Error reading the file.");
      };

      reader.readAsDataURL(selectedFile); // PDF is fine here
    } catch (error) {
      setIsLoading(false);
      console.error("Error uploading file:", error);
    }
  };

  let inputElement = null;

  inputElement = (
    <>
      <div
        className={
          "pdf-uploader-main-wrapper d-flex flex-column justify-content-start align-items-start"
        }
      >
        {data.isLable && (
          <div className={"uploader-lable"}>{data.uploaderLable}</div>
        )}
        <label
          //  key={data.key}
          className={`upload-wrapper d-flex flex-column justify-content-center align-items-center
           ${data.disabled ? "disabled" : "enabled"}`}
          onClick={!data.disabled && data.onClick}
          for={data.key}
        >
          <input
            // key={data.key}
            // id={data.key}
            type={"file"}
            onChange={!data.disabled && onChangeFile}
            style={{
              visibility: "hidden",
              cursor: data.disabled ? "auto" : "pointer",
            }}
          />
          {data.iconName && !isLoading && (
            <div className={"uw__icon"}>{GetIconByName(data.iconName)}</div>
          )}
          {isLoading && (
            <div className="loader">
              <Spin
                style={{ color: "#c40b4a" }}
                indicator={<LoadingOutlined spin />}
                size="small"
              />
            </div>
          )}
        </label>
      </div>
    </>
  );

  return <>{inputElement}</>;
};
Index.propTypes = {};

Index.defaultProps = {};
export default Index;
